import React, { useState, useEffect } from "react";
import Navigation from "./Navigation/Navigation";
import "./Header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`Header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <h1 className="logo">
          <a href="/#Main" className="logo-link">
            <span className="logo-emoji">🍰</span>
            <span className="logo-text-h">DaCakesStore</span>
          </a>
        </h1>
        <Navigation />
      </div>
    </header>
  );
}

export default Header;